<!--
  地址管理
  lovi 2020-06-30
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="id ? $t('personal.modifyAddress') : $t('personal.newAddress')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" v-if="id" class="text-blue" @click="delAddress">
        {{ $t("common.delete") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="address">
        <van-field
          v-model="name"
          :label="$t('personal.contactPerson')"
          :placeholder="$t('personal.fillConsigneeName')"
        >
          <van-radio-group
            slot="right-icon"
            direction="horizontal"
            v-model="sex"
            @change="changeRadio"
          >
            <van-radio name="1" checked-color="#2647ad">
              {{ $t("common.Mr") }}
            </van-radio>
            <van-radio name="2" checked-color="#2647ad">
              {{ $t("common.Ms") }}
            </van-radio>
          </van-radio-group>
        </van-field>
        <van-field
          v-model="mobile"
          :label="$t('personal.contact')"
          type="tel"
          :error="error.mobile ? true : false"
          :maxlength="telMax"
          :formatter="_phoneFormat"
          @input="changeMobile"
          :placeholder="$t('personal.fillReceivingPhone')"
        />
        <van-cell
          :class="addressInfo.address ? 'address' : 'not-address'"
          :title="$t('personal.shippingAddress')"
          is-link
          :value="
            addressInfo.address
              ? addressInfo.address
              : $t('personal.selectShippingAddress')
          "
          @click="mapsFlag = true"
        />
        <van-field
          v-model="addressInfo.house_number"
          :label="$t('personal.houseNumber')"
          :placeholder="$t('personal.fillDetailAddress')"
        />
      </div>
      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          :loading="btnLoading"
          @click="saveAddress"
        >
          {{ $t("personal.saveAddress") }}
        </van-button>
      </div>
    </div>

    <transition name="slide">
      <maps
        v-if="mapsFlag"
        :mapsFlag.sync="mapsFlag"
        :data="addressInfo"
        @getAddress="getAddress"
      />
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import Maps from "./maps";
export default {
  props: ["id", "detail"],
  components: {
    Maps
  },
  data() {
    return {
      mapsFlag: false,
      btnLoading: false,
      name: "",
      sex: "1",
      mobile: "",
      telMax: 13,
      error: {
        mobile: false
      },
      addressInfo: {
        address: "",
        latitude: "",
        longitude: "",
        place_id: "",
        house_number: ""
      }
    };
  },
  created() {
    if (this.id) {
      this.name = this.detail.name;
      this.sex = this.detail.sex + "";
      this.mobile = this._phoneFormat(this.detail.mobile);
      this.addressInfo.address = this.detail.address;
      this.addressInfo.latitude = Number(this.detail.latitude);
      this.addressInfo.longitude = Number(this.detail.longitude);
      this.addressInfo.place_id = this.detail.place_id;
      this.addressInfo.house_number = this.detail.house_number;
      console.log("addressInfo", this.addressInfo);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:addressFlag", false);
      this.$emit("update:id", "");
    },
    changeMobile(value) {
      // 手机
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax1 = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax1 = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.error.mobile = validate.validateMobile(phone);
    },
    changeRadio(type) {
      // Radio 单选框
      console.log("sex", type);
      this.sex = type;
    },
    getAddress(data) {
      // 获取地址信息
      console.log("getAddress", data);
      this.addressInfo.latitude = data.latitude;
      this.addressInfo.longitude = data.longitude;
      this.addressInfo.place_id = data.place_id;
      this.addressInfo.address = data.address;
    },
    saveAddress() {
      // 保存地址
      let vm = this;
      if (vm.name == "") {
        vm.$toast(vm.$t("personal.fillConsigneeName"));
        return false;
      }
      if (vm.mobile == "") {
        vm.$toast(vm.$t("personal.fillReceivingPhone"));
        return false;
      }
      if (vm.error.mobile) {
        vm.$toast(vm.error.mobile);
        return false;
      }
      if (vm.addressInfo.address == "") {
        vm.$toast(vm.$t("personal.selectShippingAddress"));
        return false;
      }
      if (vm.addressInfo.house_number == "") {
        vm.$toast(vm.$t("personal.fillDetailAddress"));
        return false;
      }
      let params = {};
      params.name = vm.name;
      params.sex = vm.sex;
      params.mobile = "0" + Number(vm.mobile.replace(/\s/g, ""));
      params.address = vm.addressInfo.address;
      params.latitude = vm.addressInfo.latitude;
      params.longitude = vm.addressInfo.longitude;
      params.place_id = vm.addressInfo.place_id;
      params.house_number = vm.addressInfo.house_number;
      let url = "";
      if (vm.id) {
        params.id = vm.id;
        url = "/app/user/addressEdit";
      } else {
        url = "/app/user/addressAdd";
      }
      vm.$post(url, params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log(url, res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$emit("update:addressFlag", false);
          vm.$emit("update:id", "");
          vm.$emit("getAddressList");
        }
      });
    },
    delAddress() {
      // 删除地址
      let vm = this;
      vm.$dialog
        .confirm({
          message: vm.$t("personal.sureDeleteAddress")
        })
        .then(() => {
          console.log("confirm");
          vm.addressDel();
        })
        .catch(() => {
          console.log("cancel");
        });
    },
    addressDel() {
      // 删除地址
      let vm = this;
      let params = {};
      params.id = vm.id;
      vm.$post("/app/user/addressDel", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("addressDel", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$emit("update:addressFlag", false);
          vm.$emit("update:id", "");
          vm.$emit("getAddressList");
        }
      });
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.address {
  padding: 15px;
  /deep/.van-cell {
    padding: 10px 0;
    &:last-child::after {
      display: inline-block;
    }
    &::after {
      left: 0;
      border-width: 1.1px;
    }
    &.address {
      .van-cell__value {
        color: #323233;
      }
    }
    &.not-address {
      .van-cell__value {
        color: #ccc;
      }
    }
    .van-cell__title {
      flex: 0 0 90px;
      width: 90px;
    }
    .van-cell__value {
      text-align: left;
    }
    .van-field__right-icon {
      margin-right: 0;
      padding: 0;
    }
    .van-radio-group {
      .van-radio--horizontal {
        margin: 0 0 0 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .van-radio__icon {
        width: 18px;
        height: 18px;
        font-size: 18px;
        .van-icon {
          font-size: 14px;
        }
      }
      .van-radio__label {
        margin-left: 3px;
        line-height: 1;
        font-size: 12px;
      }
    }
  }
}
</style>
